module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c02"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("INTERMEZZO #1")])]), _vm._v(" "), _c('div', {
    staticClass: "cst"
  }, [_c('b', [_vm._v("Why?")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("It’s any day anywhere on planet earth. A child asks, “Why?” And the designated adult has an answer.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Which of course begs another question from the child: “Why?”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Another answer.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Another question.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Why? Why? Why? On and on.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Concluding sooner or later with, “Because.”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("We are great little probers as kids. It’s one way we navigate our strange new world. Psychology calls this phase, or pathological examples of it, "), _c('i', [_vm._v("folie du pourquoi.")]), _vm._v(" a mania to ask why.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Too bad we outgrow it.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("School tests soon teach us there is one “right” answer to every question. Questioning in the workplace or on boards may be seen as threatening or disloyal. Jobs in fund development soon teach us to adopt “high-probability solutions” that pretty much always produce some kind of result. “Lessons learned,” case studies, professional development—they all aim to give us better answers than we currently have.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Sometimes, though, better answers aren’t the answer.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("What would really help are better "), _c('i', [_vm._v("questions")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Reactivate your childhood "), _c('i', [_vm._v("folie")]), _vm._v(" "), _c('i', [_vm._v("du pourquoi")]), _vm._v(". Stop assuming there are answers. Instead, start relentlessly asking questions. Of your donors. Of your prospects. Of your fundraising methods. Of your organization. Questions like “Why did you give us that first gift?” Or “What could we do better in your opinion?” Or “What happens when the grantmakers change their priorities?” Or “Are we still relevant?”")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("We believe that a question-driven fund development program lodged inside a questioning organization will "), _c('i', [_vm._v("always")]), _vm._v(" outperform and certainly outlast a complacent program inside a complacent organization.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("And you probably agree, if not from your own experience, at least instinctively. Science and art, after all, advance by asking questions, often rude, stupid, improper questions that no reasonable person would ask.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Here’s our advice to you: Don’t be a reasonable person. Being reasonable won’t tell you anything explosively new. Reasonable people already know the answers. Or assume those answers exist "), _c('i', [_vm._v("somewhere")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Well, they don’t. Each organization is different. Different time, different place, different needs, different mission, different vision, different leadership.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("For sure, this book doesn’t have all the answers. We are well aware of our limits. Oh, it has plenty of information, examples, tips, good advice from dozens of honest-to-goodness experts, sound theory and practice.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("But you will also notice lists of questions without answers. We know what you might be thinking: Aren’t books like this "), _c('i', [_vm._v("supposed")]), _vm._v(" to explain things? Isn’t that why you purchase a book like this?")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Not this time. This book is a bit different. This is a "), _c('i', [_vm._v("folie")]), _vm._v(" "), _c('i', [_vm._v("du pourquoi")]), _vm._v(" book. A “why-to” as well as a “how-to” book. “It’s about going someplace fundamentally different. Remember, it’s not the activities that lead to success. It’s the understanding that produces success.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c02_r1#en9",
      "id": "Ref-en9"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("We think the best, most profitable habit we can promote is an itch to ask lots of questions. Cage-rattling questions. Questions without known answers. Questions that turn your brain upside down and shake it until the coins fall out.")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h1"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ENDNOTE")])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c02_r1#Ref-en9",
      "id": "en9"
    }
  }, [_vm._v("1")]), _vm._v("   Remarks made by Eddie Thompson, Ed.D., Thompson & Associates, at the April 2007 Kaiser Institute.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015fbe6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aher_9781118044865_oeb_c02_r1.vue
// module id = 87
// module chunks = 0